module.exports = __webpack_public_path__ + "fonts/Ammonite-2.dc4d6d44.otf";